import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  CallStatisticsTable,
  StatisticsTable,
} from '@components/Numbers/Details/Table';
import { Page500 } from '@containers/ErrorPages';
import { numberApi } from '@reducers/number/number';

export const StatisticsTab = ({ did }) => {
  const {
    data: resultStats,
    isLoading: isLoadingStats,
    status: statusStats,
  } = numberApi.useGetStatisticsQuery({ did });
  const {
    data: resultLatestCDR,
    isLoading: isLoadingLatestCDR,
    status: statusLatestCDR,
  } = numberApi.useGetLatestCDRQuery({ did });
  const isLoading = isLoadingStats;
  const rejected = statusStats === 'rejected' || statusLatestCDR === 'rejected';

  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (rejected) {
    return <Page500 />;
  }
  return (
    <>
      <Row>
        <Col md={4}>
          <StatisticsTable
            data={[resultLatestCDR]}
            isLoading={isLoadingLatestCDR}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <CallStatisticsTable data={resultStats.inbound} title="Inbound" />
        </Col>
      </Row>
      <Row>
        <Col>
          <CallStatisticsTable data={resultStats.outbound} title="Outbound" />
        </Col>
      </Row>
    </>
  );
};
